import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import type { ConnectorProps as AppProps } from './connectors/App'
import AppConnector from './connectors/App'
import Hospitality from './layouts/Hospitality'
import Commercial from './layouts/Commercial'
import Landing from './layouts/Landing'
import Healthcare from './layouts/Healthcare'
import Residential from './layouts/Residential'
import Capabilities from './layouts/Capabilities'
const SECTIONS = {
  commercial: Commercial,
  healthcare: Healthcare,
  hospitality: Hospitality,
  residential: Residential,
  capabilities: Capabilities,
}

const Component = ({ section }: AppProps): React.ReactElement<React.ComponentProps<any>, any> => {
  const Layout = SECTIONS[section] || Landing
  return (
    <NavigationLayout>
      <Layout section={section} />
    </NavigationLayout>
  )
}

export default AppConnector(Component)